import type { ProjectData } from "./types";

export const HOSPITALITY_PROJECTS: ProjectData[] = [
  {
    id: "illy-cafe",
    slug: "illy-cafe-city-centre",
    title: "illy Café - City Centre Bahrain",
    seoTitle: "illy Café Fit-Out | City Centre Bahrain",
    seoDescription:
      "Italian coffee lounge fit-out for illy Café at City Centre Bahrain: custom walnut barista counters, brass pendant lighting and MEP by Abacus.",
    category: "F&B & Hospitality",
    location: "City Centre Bahrain, Manama",
    client: "illy Café Italy / Bahrain Franchise",
    year: "2024",
    area: "210 sq. m.",
    description:
      "Iconic Italian coffee lounge featuring custom joinery, specialized barista counters, and bespoke brass accents.",
    details:
      "Client returned after experiencing Abacus's precision execution on preliminary phases. Features hand-finished walnut wood counters and brass ceiling rings.",
    challengeNarrative:
      "Integrating heavy barista equipment, espresso water filtration lines, and refrigeration units inside elegant wooden counters.",
    solutionNarrative:
      "Coordinated MEP schematics prior to joinery fabrication, ensuring precision cutouts and concealed drainage.",
    scopeOfWork: [
      "F&B Turnkey Fit-Out & MEP",
      "Custom Walnut Barista Counter Joinery",
      "Bespoke Brass Pendant Lighting Rings",
      "Commercial Grade Kitchen Plumbing & Drainage",
      "Mall Civil & Health Authority Approvals",
    ],
    tags: [
      "F&B Fit-Out",
      "Barista Counter Joinery",
      "Abacus Luminaire Lighting",
      "Plumbing & Electrical",
    ],
    image:
      "https://vibe.filesafe.space/1785525013889768799/attachments/c9d4fce9-62f0-48c8-8dec-c769083f2da7.jpg?v=2",
    imageAlt:
      "illy Cafe interior City Centre Bahrain - barista counter custom joinery by Abacus",
    additionalImages: [
      "https://vibe.filesafe.space/1785525013889768799/attachments/9f7a8712-ae41-41ee-b30b-c69f2da12960.jpg",
      "https://vibe.filesafe.space/1785525013889768799/attachments/83685922-a882-4e8e-b383-8961738a01c6.jpg",
      "https://vibe.filesafe.space/1785525013889768799/attachments/d3ea8011-7c55-4d4d-aa1a-857c99a4cd98.jpg",
      "https://vibe.filesafe.space/1785525013889768799/attachments/88b5f8cb-0cd5-4411-b157-90b832d7fc0d.jpg",
      "https://vibe.filesafe.space/1785525013889768799/attachments/19c50d32-19b3-49f2-a1bb-2c752e2cbe91.png",
    ],
    keyHighlights: [
      "Bespoke walnut espresso bar crafted in Askar factory",
      "Integrated brass ceiling feature light engineered by Abacus Luminaire",
      "100% compliance with Ministry of Health commercial kitchen codes",
    ],
  },
  {
    id: "barrys-bahrain-al-liwan",
    slug: "barrys-bahrain-al-liwan",
    title: "Barry's Bahrain - Al Liwan",
    seoTitle: "Barry's Fitness Studio Fit-Out | Al Liwan Bahrain",
    seoDescription:
      "Boutique fitness studio fit-out for Barry's at Al Liwan Bahrain: the iconic Red Room, acoustic isolation and custom HVAC ventilation by Abacus.",
    category: "Fitness & Leisure",
    location: "Al Liwan, Bahrain",
    client: "Barry's Bootcamp Middle East",
    year: "2024",
    area: "620 sq. m.",
    description:
      "Complete studio fit-out for the world-famous boutique fitness brand - the signature Red Room workout studio, reception and retail zone, and changing facilities, delivered to strict international brand standards.",
    details:
      "Abacus carried out a full turnkey contracting program for Barry's Bahrain at Al Liwan, featuring complex acoustic isolation, specialized high-intensity studio lighting (the iconic Red Room), custom reception counters, and specialized HVAC ventilation systems.",
    challengeNarrative:
      "Achieving total sound containment for intense workout music while handling massive HVAC airflow requirements inside the Red Room.",
    solutionNarrative:
      "Installed floating acoustic subfloors and isolated wall baffles combined with custom high-CFM air handling units.",
    scopeOfWork: [
      "Turnkey Fitness Studio Fit-Out",
      "Specialised High-Intensity Red Room Lighting",
      "Acoustic Isolation & Soundproofing Walls",
      "High-CFM Industrial HVAC & Air Filtration",
      "Custom Reception & Luxury Locker Joinery",
    ],
    tags: [
      "Turnkey Fit-Out",
      "Specialist Lighting",
      "HVAC & Ventilation",
      "Brand-Standard Delivery",
    ],
    image:
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a917db6d6d6b7ebddb34eb3.webp",
    imageAlt:
      "Barry's Bootcamp fitness studio fit-out Al Liwan Bahrain - Red Room studio by Abacus",
    verifyNote:
      "Red Room studio, reception/retail & changing facilities scope confirmed - IG reel verifies project delivery.",
    additionalImages: [
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a917db6854f9696b3b31ac0.png",
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a917db6d75a45860e6b9ba3.webp",
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a917db60914f11215eaa256.png",
      "https://assets.cdn.filesafe.space/TkZSxIjkCDLzrMPXgP9Q/media/6a917db6626105f9559bf65e.png",
    ],
    keyHighlights: [
      "Iconic Barry's Red Room lighting programmed and commissioned in-house",
      "Zero sound leakage to neighboring retail tenants",
      "Luxury changing rooms with custom stone vanities and lockers",
    ],
  },
];
